import fetch from "fetch-retry";
import { fetchUrl, GLOBAL_FETCH_SIGNAL } from "./settings";
import { ActionType } from "../action-types";

export const pollSystems = () => (dispatch, getState) => {
    if (!getState.isLoading) {
        let token = localStorage.getItem("w4-token");
        fetch(`${fetchUrl}/systems`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            },
            signal: GLOBAL_FETCH_SIGNAL,
        })
            .then((resp) => {
                return resp.json();
            })
            .then(data => {
                if (!data) {
                    data = [];
                }
                dispatch({
                    type: ActionType.GET_SYSTEMS,
                    systems: data
                });
            })
            .catch(err => {
                dispatch({
                    type: ActionType.FETCH_ERROR,
                    error: err
                })
            })
    }
}